import { render, staticRenderFns } from "./DocumentsKycTab.vue?vue&type=template&id=d07be6ca&scoped=true"
import script from "./DocumentsKycTab.vue?vue&type=script&lang=js"
export * from "./DocumentsKycTab.vue?vue&type=script&lang=js"
import style0 from "./DocumentsKycTab.vue?vue&type=style&index=0&id=d07be6ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07be6ca",
  null
  
)

export default component.exports